export const postMessage = (kind, data) => {
  window.parent.postMessage(
    JSON.stringify({
      kind,
      ...data,
    }),
    '*',
  );
};
